module.exports = __webpack_public_path__ + "img/logo.309e1adb.svg";